import React, { useContext } from 'react';
import { Container, getStateColors, Icon, InputContainer, TextInput } from './Input.styled';
import { ComponentProps, IconPosition } from './Input.types';
import { ThemeContext } from '@emotion/core';

const Input = React.forwardRef<HTMLInputElement, ComponentProps>(
  ({ state, beforeInput, leftIcon, rightIcon, ...props }, ref) => {
    const themeContext = useContext(ThemeContext);
    const stateColors = getStateColors();
    const stateColor = state && Object.keys(stateColors).includes(state) ? stateColors[state] : stateColors.default;

    return (
      <Container state={state} disabled={props.disabled} value={props.value}>
        {leftIcon !== undefined && <Icon iconPosition={IconPosition.LEFT}>{leftIcon(stateColor)}</Icon>}
        <InputContainer>
          {beforeInput && beforeInput}
          <TextInput ref={ref} {...props} />
        </InputContainer>
        {rightIcon !== undefined && <Icon iconPosition={IconPosition.RIGHT}>{rightIcon(stateColor)}</Icon>}
      </Container>
    );
  },
);

export default Input;
